module.exports = __webpack_public_path__ + "img/logo-gu.e1244e02.svg";